var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIdentify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 526.385 382.399",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "identify_svg__a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4070 633h211v182h-211z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "identify_svg__icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.6 39a38.7 38.7 0 01-38.7 38.7A38.7 38.7 0 01224.2 39 38.7 38.7 0 01262.9.3 38.7 38.7 0 01301.6 39z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4199 -662)",
    clipPath: "url(#identify_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3880 792a50 50 0 01-50 50 50 50 0 01-50-50 50 50 0 0150-50 50 50 0 0150 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3980 792h100v100h-100z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.6 268a38.7 38.7 0 01-38.7 38 38.7 38.7 0 01-38.7-38 38.7 38.7 0 0138.7-39 38.7 38.7 0 0138.7 39z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4199 -433.1)",
    clipPath: "url(#identify_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3880 792a50 50 0 01-50 50 50 50 0 01-50-50 50 50 0 0150-50 50 50 0 0150 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3980 792h100v100h-100z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89 268a38.7 38.7 0 01-38.7 38.7A38.7 38.7 0 0111.6 268a38.7 38.7 0 0138.7-38.7A38.7 38.7 0 0189 268z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3979 -433.1)",
    clipPath: "url(#identify_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3880 792a50 50 0 01-50 50 50 50 0 01-50-50 50 50 0 0150-50 50 50 0 0150 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3980 792h100v100h-100z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M515 268a38.7 38.7 0 01-38.7 38.7 38.7 38.7 0 01-38.7-38.7 38.7 38.7 0 0138.7-38.7A38.7 38.7 0 01515 268z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4409 -433.1)",
    clipPath: "url(#identify_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3880 792a50 50 0 01-50 50 50 50 0 01-50-50 50 50 0 0150-50 50 50 0 0150 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3980 792h100v100h-100z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 172h433v5H45zM45 177h5v40h-5zM472 177h5v40h-5zM258.48 177h5v40h-5z"
  }))));
}

export default SvgIdentify;